import Mapbox from 'index.vue';

export class BaseLayer {

    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected slot: any = null;
    constructor(mapboxInstance: InstanceType<typeof Mapbox>,slot: any) {
        this.mapboxInstance = mapboxInstance;
        this.slot = slot;
    }
    
    public LoadImages(urls: Set<string>) {
        const uniqueIcons = Array.from(urls);
        return [...uniqueIcons].map((iconUrl) => {
            if (!this.mapboxInstance.map.hasImage(iconUrl)) {
                return new Promise<void>((resolve, reject) => {
                    this.mapboxInstance.map.loadImage(iconUrl, (error: any, image: any) => {
                        if (error) {
                            console.error(`Error loading image: ${iconUrl}`, error);
                            reject(error);
                            return;
                        }
                        if (image) {
                            this.mapboxInstance.map.addImage(iconUrl, image, { pixelRatio: 2 });
                            resolve();
                        } else {
                            reject(new Error('Image not found'));
                        }
                    });
                });
            } else {
                // If the image already exists, resolve immediately
                return Promise.resolve();
            }
        });
    }
}